import React from 'react';
import NutritionalDashboard from '../NutritionalDashboard';
import NutritionalAlertsPanel from '../NutritionalAlertsPanel';
import FeedQuantityEstimationComponent from '../FeedQuantityEstimation';
import NutritionalAnalysisPanel from '../NutritionalAnalysisPanel';
import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import { DailyFeedMix, NutritionalAnalytics, NutritionalTrendData } from '../../api/nutrition';

interface NutritionOverviewPanelProps {
  dashboardData: any;
  trends: { data: NutritionalTrendData[]; analytics: NutritionalAnalytics } | null;
  dailyMixes: DailyFeedMix[];
  selectedLocation: string;
  onRefresh: () => void;
  onViewMixes: () => void;
  onViewTrends: () => void;
}

export default function NutritionOverviewPanel({
  dashboardData,
  trends,
  dailyMixes,
  selectedLocation,
  onRefresh,
  onViewMixes,
  onViewTrends,
}: NutritionOverviewPanelProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-4">
        <div className="space-y-6 xl:col-span-3">
          {dashboardData && (
            <NutritionalDashboard data={dashboardData} trends={trends} onRefresh={onRefresh} />
          )}

          {dashboardData?.feedQuantityEstimation && (
            <FeedQuantityEstimationComponent data={dashboardData.feedQuantityEstimation} />
          )}

          {dailyMixes.length > 0 && (
            <NutritionalAnalysisPanel
              nutritionalSummary={dailyMixes[0].nutritionalSummary}
              totalQuantity={dailyMixes[0].nutritionalSummary.totalQuantity}
            />
          )}

          {trends && trends.data.length > 0 && (
            <button
              type="button"
              onClick={onViewTrends}
              className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-4 text-left shadow-sm hover:bg-slate-50"
            >
              <div>
                <p className="text-sm font-semibold text-slate-900">Trends & reports</p>
                <p className="mt-0.5 text-sm text-slate-500">
                  Avg quality {Number(trends.analytics.averages.qualityScore || 0).toFixed(0)}/100 over {trends.data.length} days
                </p>
              </div>
              <ArrowTrendingUpIcon className="h-5 w-5 text-cyan-600" aria-hidden />
            </button>
          )}
        </div>

        <div className="xl:col-span-1">
          <NutritionalAlertsPanel selectedLocation={selectedLocation} onAlertAction={onRefresh} />
          {dailyMixes.length > 0 && (
            <button
              type="button"
              onClick={onViewMixes}
              className="mt-4 w-full rounded-lg border border-gray-200 bg-white px-4 py-3 text-left text-sm text-slate-700 shadow-sm hover:bg-slate-50"
            >
              <span className="font-medium text-slate-900">{dailyMixes.length} daily mix{dailyMixes.length !== 1 ? 'es' : ''}</span>
              <span className="mt-0.5 block text-slate-500">View and manage in Records →</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
